var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArtWalkLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 40,
    viewBox: "0 0 179 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0845 6.66663H63.467V40H40.0845V6.66663Z",
    fill: "#80CDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4771 6.66663H91.8595V40H68.4771V6.66663Z",
    fill: "#FF9369"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1811 40H19.1961L13.7037 0H5.1117L0 40H6.41682L7.06938 33.2796H11.4198L12.1811 40ZM9.19019 12.6882L10.7128 26.3978H7.77632L9.19019 12.6882Z",
    fill: "#131313"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4418 22.9032H28.9645C30.4327 22.9032 30.8678 23.3871 30.8678 25.2688V36.9355C30.8678 38.7097 31.1397 39.5699 31.5203 40H38.7529V39.7312C38.481 39.2473 38.1547 38.4946 38.1547 36.7742V23.172C38.1547 20.215 36.197 18.871 35.055 18.4409C36.4145 17.8495 38.2634 16.3978 38.2634 13.0645V6.66667C38.2634 2.36559 36.0339 0 31.6291 0H20.2093V40H27.4418V22.9032ZM27.4418 6.1828H29.0732C30.5415 6.1828 30.8678 6.72043 30.8678 8.44086V13.871C30.8678 15.7527 30.324 16.2903 28.8557 16.2903H27.4418V6.1828Z",
    fill: "#131313"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0843 0V6.75678H62.6317V40H69.3124V6.75678H91.8598V0H40.0843Z",
    fill: "#131313"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102.959 25.6452L105.569 0H112.475L115.031 25.3763L117.424 0H124.384L119.218 40H111.007L108.886 18.0107L106.765 40H98.2277L93.1704 0H100.675L102.959 25.6452Z",
    fill: "#131313"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.785 40H134.771L134.009 33.2796H129.659L129.006 40H122.589L127.701 0H136.293L141.785 40ZM133.302 26.3978L131.78 12.6882L130.366 26.3978H133.302Z",
    fill: "#131313"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M142.799 0V40H157.699V32.7957H150.031V0H142.799Z",
    fill: "#131313"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M171.387 40L166.547 23.0645V40H159.315V0H166.547V15.3763L171.278 0H178.402L172.692 18.172L179 40H171.387Z",
    fill: "#131313"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtWalkLogo);
export default __webpack_public_path__ + "static/media/ArtWalkLogo.431f91fc7efb5cc96918c22ca7fd495e.svg";
export { ForwardRef as ReactComponent };